import { kubernetesEndpoint } from "../../variables/services";



export const get_cluster_status = (cluster_id, setStatus) => {
    const queryParams = new URLSearchParams({agent_id: cluster_id}).toString();
    fetch(`${kubernetesEndpoint}/status?${queryParams}`, {
            method: "GET",
            credentials: "include",
            headers: {
            "Content-Type": "application/json"
            }
        })
        .then(res => {
            if (!res.ok) { 
            return res.json().then(data => {
                throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
            });
            }
            return res.json();
        })
        .then(data => {
            setStatus(data.status);
        })
        .catch(error => {
            console.error("Error checking clusters status: ", error);
        });
}

export const isIstioInstalled = (cluster_id, setIstioInstalled) => {
    const queryParams = new URLSearchParams({agent_id: cluster_id}).toString();
    fetch(`${kubernetesEndpoint}/is_istio_installed?${queryParams}`, {
            method: "GET",
            credentials: "include",
            headers: {
            "Content-Type": "application/json"
            }
        })
        .then(res => {
            if (!res.ok) { 
            return res.json().then(data => {
                throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
            });
            }
            return res.json();
        })
        .then(data => {
            setIstioInstalled(data.istio_installed);
        })
        .catch(error => {
            console.error("Error checking clusters status: ", error);
        });
}


export const get_agent_latest_version = async () => {
    return fetch(`${kubernetesEndpoint}/get_agent_version`, {
            method: "GET",
            credentials: "include",
            headers: {
            "Content-Type": "application/json"
            }
        })
        .then(res => {
            if (!res.ok) { 
            return res.json().then(data => {
                throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
            });
            }
            return res.json();
        })
        .then(data => {
            return data.version
        })
        .catch(error => {
            console.error("Error getting agent_version: ", error);
        });
}

